export const createCities = (country, cities, countryCode) => {
  return cities.map(city => ({ ...city, name: city.name + ', ' + country, countryCode }))
}

export const createCountry = (country, cities, countryCode) => {
  const citiesHotels = cities.reduce((acc, curr) => {
    return [...acc, ...curr.hotels]
  }, [])

  return { name: country, code: countryCode, hotels: citiesHotels }
}
